import React from 'react';
import { Zap, Clock, Heart } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: Zap,
      title: 'Sustained Energy',
      description: 'No spike. No crash. Just steady power all morning.'
    },
    {
      icon: Clock,
      title: 'Ready in Seconds',
      description: 'Under 60 seconds. Bowl or shake. Your choice.'
    },
    {
      icon: Heart,
      title: 'Complete Nutrition',
      description: '21 vitamins & minerals. Immune support with Sumodulin™.'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <p className="text-[#8B6F47] text-sm tracking-widest uppercase mb-4">
              The Ready Solution
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C2416] mb-6 leading-tight">
              Your day starts <br />with substance.
            </h2>
            <p className="text-lg text-[#5C4033] mb-12 leading-relaxed">
              Most breakfasts spike your blood sugar and leave you crashing by 10am. 
              GUAG is different — balanced macros, high protein, low sugar, high fibre. 
              Energy that lasts.
            </p>

            {/* Benefits List */}
            <div className="space-y-8">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div key={index} className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-[#8B6F47] rounded-full flex items-center justify-center">
                        <Icon className="text-white" size={24} />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-[#2C2416] mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-[#5C4033]">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src="https://d64gsuwffb70l.cloudfront.net/6851587676ae218610324179_1769273859993_f5040020.png"
              alt="GUAG Family Lifestyle"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;